import styled from 'styled-components';

export const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e3e3e3;
  border-radius: 15px;
  margin-right: .625rem;
  height: ${props => (props.width === 1 ? '6.25rem' : `${props.width}px`)};
  width: ${props => (props.width === 1 ? '6.25rem' : `${props.width}px`)};
  min-width: ${props => (props.width === 1 ? '6.25rem' : `${props.width}px`)};
  background: #fff;
  color: ${props => { return props.theme.color.primaryColor }};
  padding: 5px;

  &.active, &:hover {
    background: ${props => { return props.theme.color.primaryColor }};
    border: ${props => { return `2px solid ${props.theme.color.primaryColor}` }};
    color: #fff;
    cursor: pointer;
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
    max-width: 100%;
    i {
      font-size: 2.5rem;
    }
    p {
      font-size: ${props => `${14*props.theme.font.primaryFont.scaling/100}px`};
      line-height: 1.25rem;
      font-weight: ${props => parseInt(props.theme.font.primaryFont.weight)};
      margin: 0;
      text-align: center;
      height: 40px;
      display: flex;
      align-items: center;
    }
  }
`;
